var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-layout',[_c('a-layout-header',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"brand-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png")}}),_c('span',{staticClass:"brand"},[_vm._v(_vm._s(_vm.$t('message.title')))])]),_c('div')])]),_c('a-layout-content',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }